// MUTATIONS
export const SET_SELECTED_TAB = 'matching/SET_SELECTED_TAB'
export const SET_TIMELINE_VALUE = 'matching/SET_TIMELINE_VALUE'
export const SET_INCOMING_PAYMENTS = 'matching/SET_INCOMING_PAYMENTS'
export const SET_IS_LOADING = 'mathing/SET_IS_LOADING'
export const SET_FILTERS = 'matching/SET_FILTERS'
export const SET_PAGINATION = 'matching/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'matching/SET_TOTAL_ITEMS'
export const SET_MATCHING_ACTION = 'matching/SET_MATCHING_ACTION'
export const SET_DEFAULT_VALUES = 'matching/SET_DEFAULT_VALUES'
export const SET_SELECTED_TO_SEND = 'matching/SET_SELECTED_TO_SEND'
export const SET_SELECTED_TO_SETTLE = 'matching/SET_SELECTED_TO_SETTLE'
export const ADD_SELECTED_TO_SETTLE_ETP = 'matching/ADD_SELECTED_TO_SETTLE_ETP'
export const REMOVE_SELECTED_TO_SETTLE_ETP =
  'matching/REMOVE_SELECTED_TO_SETTLE_ETP'
export const SET_SETTLE_PAYMENT_INFO = 'matching/SET_SETTLE_PAYMENT_INFO'
export const SET_SELECTED_SETTLEMENT = 'matching/SET_SELECTED_SETTLEMENT'
export const SET_AMOUNT_TO_DISCOUNT = 'matching/SET_AMOUNT_TO_DISCOUNT'
export const SET_STATEMENT_TO_DELETE = 'matching/SET_STATEMENT_TO_DELETE'
export const SET_PAYMENT_RESULT = 'matching/SET_PAYMENT_RESULT'
export const SET_SUCCESS_MESSAGE = 'matching/SET_SUCCESS_MESSAGE'
export const SET_BENEFICIARY_INFO = 'matching/SET_BENEFICIARY_INFO'
export const SET_RESULTS_LIST = 'matching/SET_RESULTS_LIST'
export const SET_SETTLE_PAGINATION_TOTAL =
  'matching/SET_SETTLE_PAGINATION_TOTAL'
export const SET_SETTLE_AS_DEPOSIT_DIALOG =
  'matching/SET_SETTLE_AS_DEPOSIT_DIALOG'
export const SET_NEW_SETTLE_AMOUNT_VALUE =
  'matching/SET_NEW_SETTLE_AMOUNT_VALUE'
export const RESET_SETTLE_VALUES = 'matching/RESET_SETTLE_VALUES'
export const SET_SETTLE_DEPOSIT_DIALOG_CONFIRMATION =
  'matching/SET_SETTLE_DEPOSIT_DIALOG_CONFIRMATION'
export const SET_SEARCH_RESULTS_ETP = 'matching/SET_SEARCH_RESULTS_ETP'
export const SET_SELECTED_TO_SETTLE_ETP = 'matching/SET_SELECTED_TO_SETTLE_ETP'

// ACTIONS
export const CHANGE_SELECTED_TAB = 'matching/CHANGE_SELECTED_TAB'
export const GET_MATCHING = 'matching/GET_MATCHING'
export const CHANGE_PAGINATION = 'matching/CHANGE_PAGINATION'
export const RESET_PAGINATION = 'matching/RESET_PAGINATION'
export const CHANGE_FILTERS = 'matching/CHANGE_FILTERS'
export const UPDATE_MATCHING_ACTIONS = 'matching/UPDATE_MATCHING_ACTIONS'
export const MARK_AS_RESOLVED = 'matching/MARK_AS_RESOLVED'
export const RESET_MATCHING_VALUES = 'matching/RESET_MATCHIG_VALUES'
export const MARK_AS_UNMATCHED = 'matching/MARK_AS_UNMATCHED'
export const UPDATE_TIMELINE = 'matching/UPDATE_TIMELINE'
export const COMMENT_INCOMING_PAYMENT = 'matching/COMMENT_INCOMING_PAYMENT'
export const UPDATE_SELECTED_TO_SEND = 'matching/UPDATE_SELECTED_TO_SEND'
export const CLEAR_SELECTED_TO_SEND = 'matching/CLEAR_SELECTED_TO_SEND'
export const PUSH_SELECTED_TO_SETTLE = 'matching/PUSH_SELECTED_TO_SETTLE'
export const SPLICE_SELECTED_TO_SETTLE = 'matching/SPLICE_SELECTED_TO_SETTLE'
export const CHANGE_SETTLE_USE_DEPOSIT = 'matching/CHANGE_SETTLE_USE_DEPOSIT'
export const GET_SELECTED_SETTLEMENT = 'matching/GET_SELECTED_SETTLEMENT'
export const GET_SETTLE_PAYMENT_INFO = 'matching/GET_SETTLE_PAYMENT_INFO'
export const ADD_TO_SETTLE = 'matching/ADD_TO_SETTLE'
export const DELETE_STATEMENT = 'matching/DELETE_STATEMENT'
export const SEND_PAYMENT = 'matching/SEND_PAYMENT'
export const SEND_SETTLED_INVOICES = 'matching/SEND_SETTLED_INVOICES'
export const SEND_SETTLED_PAYABLES = 'matching/SEND_SETTLED_PAYABLES'
export const GET_BANK_ACCOUNTS = 'matching/GET_BANK_ACCOUNTS'
export const GET_BENEFICIARY_INFO = 'matching/GET_BENEFICIARY_INFO'
export const SORT_RESULTS_BY_STATUS = 'matching/SORT_RESULTS_BY_STATUS'
export const GET_LIST_RESULTS = 'matching/GET_LIST_RESULTS'

// GETTERS
export const PARAMS_TO_SEND = 'matching/PARAMS_TO_SEND'
export const MATCHING_TO_SHOW = 'matching/MATCHING_TO_SHOW'
export const SETTLE_TOTAL_AMOUNT = 'matching/SETTLE_TOTAL_AMOUNT'
export const SETTLE_TOTAL_AMOUNT_ETP = 'matching/SETTLE_TOTAL_AMOUNT_ETP'
export const DISABLE_SETTLE_BUTTON = 'matching/DISABLE_SETTLE_BUTTON'
export const INVALID_SETTLE_TOTAL_AMOUNT_ETP =
  'matching/INVALID_SETTLE_TOTAL_AMOUNT_ETP'
